import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs";

import { BASE_URLS, DISCOVERY_SERVICES_URLS } from "@tci/common";

/**
 * `/tsc-orchestrator/v2` APIs are the ones that are exposed on TCI's domain name by TSC.
 */
@Injectable()
export class NgTscOrchestratorService {
    private static instance: NgTscOrchestratorService = null;

    public static getInstance(
        http: Http
    ): NgTscOrchestratorService {
        if (!NgTscOrchestratorService.instance) {
            NgTscOrchestratorService.instance = new NgTscOrchestratorService(http);
        }
        return NgTscOrchestratorService.instance;
    }

    public getGridDetails(): Observable<any> {
        return this
            .http
            .get(`${DISCOVERY_SERVICES_URLS.TSC_ORCHESTRATOR}${BASE_URLS.TSC_ORCHESTRATOR_V2}/griddetails`)
            .map(res => res.json() || {})
            .catch(error => {
                console.log("Error getting TSC Grid Details: ", error);
                return Observable.of(null);
            });
    }

    private constructor(
        private http: Http
    ) {}
}
